export const transformStringToNumber = (val: string): string | number => {
  const convertedValue = parseInt(val);
  return isNaN(convertedValue) ? val : convertedValue;
};

export const transformRawPhoneNumber = (val: string): string => {
  return (val + '').replace(/[^0-9]/g, '');
};
